import {Injectable} from '@angular/core';
import {Diagram, DiagramPort, DiagramUnit} from '@catcore/services/diagram/diagram';
import {RestHttpService} from '@catcore/services/rest-http.service';
import {Restangular} from 'ngx-restangular';
import {Observable} from "rxjs";

@Injectable()
export class DiagramUnitService extends RestHttpService<any> {
  constructor(service: Restangular) {
    super('diagram-units', service);
  }
}

@Injectable()
export class DiagramPortService extends RestHttpService<any> {
  constructor(service: Restangular) {
    super('diagram-ports', service);
  }
}

@Injectable()
export class DiagramService extends RestHttpService<Diagram> {

  constructor(service: Restangular,
              private diagramUnitService: DiagramUnitService,
              private diagramPortService: DiagramPortService) {
    super('diagrams', service);
  }

  /**
   * Updates the diagram and each unit or port that is marked dirty. After
   * a unit/port has been updated, the dirty flag is removed.
   *
   * @param diagram
   */
  update(diagram: any) {
    const requests = [];

    requests.push(super.update({
      _links: [{
        self: {
          href: diagram._links.self.href,
        },
      }],
      zoom_factor: diagram.zoom_factor,
      width: diagram.width,
      height: diagram.height,
      id: diagram.id,
    }));

    if (diagram._embedded && diagram._embedded.diagram_units) {
      diagram._embedded.diagram_units.forEach((unit) => {
        if (unit['dirty']) {
          requests.push(this.diagramUnitService.update({
            id: unit.id,
            x: unit.x,
            y: unit.y,
            width: unit.width,
          }).map((result) => {
            delete unit['dirty'];
            return result;
          }));
        }
        if (unit._embedded && unit._embedded.diagram_ports) {
          unit._embedded.diagram_ports.forEach((diagramPort) => {
            if (diagramPort['dirty']) {
              requests.push(this.diagramPortService.update({
                id: diagramPort.id,
                x: diagramPort.x,
                y: diagramPort.y,
              }).map((result) => {
                delete diagramPort['dirty'];
                return result;
              }));
            }
          });
        }
      });
    }

    return Observable.forkJoin(requests);
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/core/services/diagram/diagram.service.ts